export enum RelationsGoogleUserEnum {
	Manager = 'manager'
}
